import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar-nav" }
const _hoisted_2 = { class: "nav-item" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bars" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "navbar-nav ml-auto" }

export function render(_ctx, _cache) {
  const _component_languages_dropdown = _resolveComponent("languages-dropdown")
  const _component_user_logout = _resolveComponent("user-logout")

  return (_openBlock(), _createElementBlock("nav", {
    id: "main-header",
    class: _normalizeClass(["main-header navbar navbar-expand", _ctx.navbarVariant])
  }, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("button", {
          class: "nav-link",
          role: "button",
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.onToggleMenuSidebar && _ctx.onToggleMenuSidebar(...args)))
        }, _hoisted_4)
      ])
    ]),
    _createElementVNode("ul", _hoisted_5, [
      _createVNode(_component_languages_dropdown),
      _createVNode(_component_user_logout)
    ])
  ], 2))
}